import { useEffect, useState } from 'react';
import { EditorState, convertToRaw, convertFromRaw } from 'draft-js';
import { Editor } from 'react-draft-wysiwyg';
import axios from 'axios';
import styles from './sportModuleForm.module.css';
import stylesDefault from '../default.module.css';
import Select from 'react-select';
import { Icons } from '../../../../code/IconHandler';
import AppointmentEditor from '../AppointmentEditor/AppointmentEditor';
import PersonSelection from '../../ToolComponents/PersonSelection/PersonSelection';
import { showErrorToast } from '../../../../code/ToastHelper';
export default function SportmodulForm({ item, onClose, onSave }) {
    const [moduleInfos, setModuleInfos] = useState(
        item?.modules || [
            { title: '', iconPath: '', iconText: '', category: '', anchor_id: '' }
        ]
    );
    const [searchTerm, setSearchTerm] = useState('');
    const [selectedModuleIndex, setSelectedModuleIndex] = useState(null);
    const [showIconPicker, setShowIconPicker] = useState(false);
    const [assignments, setAssignments] = useState(item?.assignments || []);
    const [allPersons, setAllPersons] = useState([]);
    const [appointments, setAppointments] = useState(item?.appointments || []);
    const [categories, _] = useState([
        { value: 'fitness-und-entspannung', label: 'Fitness und Entspannung', parent: 'Erlebnissport' },
        { value: 'sport-und-natur', label: 'Sport und Natur', parent: 'Erlebnissport' },
        { value: 'turnen', label: 'Turnen', parent: 'Erlebnissport' },
        { value: 'tanzen', label: 'Tanzen', parent: 'Erlebnissport' },
        { value: 'praevention', label: 'Prävention', parent: 'Gesundheitssport' },
        { value: 'reha', label: 'Reha', parent: 'Gesundheitssport' }
    ]);
    const [iconOptions, setIconOptions] = useState([]);
    const [main_text, setmain_text] = useState(
        item?.main_text
            ? EditorState.createWithContent(convertFromRaw(JSON.parse(item.main_text)))
            : EditorState.createEmpty()
    );
    const [ziel_gruppe, setziel_gruppe] = useState(
        item?.ziel_gruppe
            ? EditorState.createWithContent(convertFromRaw(JSON.parse(item.ziel_gruppe)))
            : EditorState.createEmpty()
    );
    const [kosten, setKosten] = useState(
        item?.kosten
            ? EditorState.createWithContent(convertFromRaw(JSON.parse(item.kosten)))
            : EditorState.createEmpty()
    );
    const [mitbringen, setMitbringen] = useState(
        item?.mitbringen
            ? EditorState.createWithContent(convertFromRaw(JSON.parse(item.mitbringen)))
            : EditorState.createEmpty()
    );
    const [infos_lehrer, setinfos_lehrer] = useState(
        item?.infos_lehrer
            ? EditorState.createWithContent(convertFromRaw(JSON.parse(item.infos_lehrer)))
            : EditorState.createEmpty()
    );

    const token = localStorage.getItem('token');

    const addContact = (contact) => {
        setAssignments(prev => [
            ...prev,
            {
                id: null, // Not persisted yet
                contact,
                position: '',
                aufgabe: '',
                show_email: true,
                show_phone: true,
            }
        ]);
    };

    const removeContact = (contactId) => {
        setAssignments(prev => prev.filter(a => a.contact.id !== contactId));
    };

    const updatePosition = (contactId, newPosition) => {
        setAssignments(prev => prev.map(a =>
            a.contact && a.contact.id === contactId ? { ...a, position: newPosition } : a
        ));
    };

    const updateAufgabe = (contactId, newAufgabe) => {
        setAssignments(prev => prev.map(a =>
            a.contact && a.contact.id === contactId ? { ...a, aufgabe: newAufgabe } : a
        ));
    };

    const toggleEmailVisibility = (contactId) => {
        setAssignments(prev => prev.map(a =>
            a.contact && a.contact.id === contactId ? { ...a, show_email: !a.show_email } : a
        ));
    };

    const togglePhoneVisibility = (contactId) => {
        setAssignments(prev => prev.map(a =>
            a.contact && a.contact.id === contactId ? { ...a, show_phone: !a.show_phone } : a
        ));
    };
    useEffect(() => {
        axios.get('/api/contact', {
            headers: { Authorization: `Bearer ${token}` }
        }).then(res => {
            const contacts = res.data;
            setAllPersons(contacts);

            if (item?.assignments) {
                const assignmentsWithContacts = item.assignments.map(a => ({
                    ...a,
                    contact: contacts.find(c => c.id === a.contact_id) || null,
                }));
                setAssignments(assignmentsWithContacts);
            }
        });

        // Load icons
        fetch('/api/upload/list-icons')
            .then(res => res.json())
            .then(data => {
                console.log(data[0]);
                setIconOptions(data[0]);
            })
            .catch(err => console.error("Failed to load icons:", err));
    }, [item, token]);

    function isEditorEmpty(editorState) {
        const content = editorState.getCurrentContent();
        const blocks = content.getBlocksAsArray();
        return blocks.length === 1 && blocks[0].getText().trim() === "";
    }

    const handleSubmit = async () => {
        const payload = {
            modules: moduleInfos.map(mod => ({
                ...mod,
                // Optionally attach id if editing a module entry
                id: mod.id || null
            })),
            appointments: appointments.map(app => ({
                ...app,
                id: app.id || null,
                topic_type: 'sportModule',
            })),
            assignments: assignments.map(a => ({
                id: a.id || null,
                contact_id: a.contact.id,
                position: a.position,
                aufgabe: a.aufgabe,
                show_email: a.show_email,
                show_phone: a.show_phone,
            })),
            main_text: isEditorEmpty(main_text) ? null : JSON.stringify(convertToRaw(main_text.getCurrentContent())),
            ziel_gruppe: isEditorEmpty(ziel_gruppe) ? null : JSON.stringify(convertToRaw(ziel_gruppe.getCurrentContent())),
            kosten: isEditorEmpty(kosten) ? null : JSON.stringify(convertToRaw(kosten.getCurrentContent())),
            mitbringen: isEditorEmpty(mitbringen) ? null : JSON.stringify(convertToRaw(mitbringen.getCurrentContent())),
            infos_lehrer: isEditorEmpty(infos_lehrer) ? null : JSON.stringify(convertToRaw(infos_lehrer.getCurrentContent())),
        };
        try {
            if (item) {
                await axios.put(`/api/sportmodule/${item.id}`, payload, {
                    headers: { Authorization: `Bearer ${token}` }
                });
            } else {
                await axios.post('/api/sportmodule', payload, {
                    headers: { Authorization: `Bearer ${token}` }
                });
            }
            onSave();
        } catch (e) {
            console.error(e);
            showErrorToast('Fehler beim Speichern.');
        }
    };

    const toolbar = {
        options: [
            'inline',
            'blockType',
            'list',
            'textAlign',
            'link',
            'emoji',
            'history'
        ],
        blockType: {
            options: [
                'Normal', // unstyled text
                'H2',
                'H3',
            ],
        },
        inline: {

            options: ['bold', 'italic', 'underline', 'strikethrough', 'monospace', 'superscript', 'subscript'],
        },
        list: {

            options: ['unordered', 'ordered', 'indent', 'outdent'],
        },
        textAlign: {

            options: ['left', 'center', 'right', 'justify'],
        },
        link: {
            inDropdown: true,
            options: ['link', 'unlink'],
        },
        history: {
            options: ['undo', 'redo'],
        }
    }

    return (
        <div className={stylesDefault.modalOverlay}>
            <div className={stylesDefault.modalForm}>
                <button
                    type="button"
                    onClick={onClose}
                    style={{
                        position: 'absolute',
                        top: '0.75rem',
                        right: '0.75rem',
                        background: 'transparent',
                        border: 'none',
                        cursor: 'pointer',
                        padding: 0,
                    }}
                    title="Schließen"
                    aria-label="Close modal"
                >
                    <Icons.X size={24} color="#333" />
                </button>
                <h2 className={styles.title}>{item ? 'Modul bearbeiten' : 'Neues Modul erstellen'}</h2>

                {/* ======= GENERAL MODULE INFO ======= */}
                <div>
                    {moduleInfos.map((mod, index) => (
                        <fieldset className={styles.group} key={index} style={{ position: 'relative' }}>
                            <legend>Modul {index + 1}</legend>
                            <button
                                type="button"
                                onClick={() => {
                                    const confirmDelete = window.confirm("Sind sie sicher, dass sie dieses Modul löschen möchten?");
                                    if (confirmDelete) {
                                        const updatedModules = moduleInfos.filter((_, i) => i !== index);
                                        setModuleInfos(updatedModules);
                                    }
                                }}
                                style={{
                                    position: 'absolute',
                                    top: '0.5rem',
                                    right: '0.5rem',
                                    background: 'transparent',
                                    border: 'none',
                                    cursor: 'pointer',
                                    padding: 0,
                                }}
                                title="Modul entfernen"
                            >
                                <Icons.Delete size={18} color="#900" />
                            </button>
                            <div>
                                <label className={styles.label}>Titel</label>
                                <input
                                    className={styles.input}
                                    value={mod.title}
                                    onChange={e => {
                                        const copy = [...moduleInfos];
                                        copy[index].title = e.target.value;
                                        setModuleInfos(copy);
                                    }}
                                />
                            </div>

                            <div className={styles.iconDiv}>
                                <div>
                                    <label className={styles.label}>Icon Pfad</label>
                                    <div style={{ display: 'flex', gap: '1rem', alignItems: 'center' }}>
                                        <button
                                            type="button"
                                            className={styles.openButton}
                                            onClick={() => {
                                                setSelectedModuleIndex(index);  // <- Pass the current index
                                                setShowIconPicker(true);
                                            }}
                                        >
                                            Icon wählen
                                        </button>
                                        {mod.iconPath && (
                                            <img src={mod.iconPath} alt="selected icon" style={{ marginTop: '0.5rem', maxHeight: 50 }} />
                                        )}
                                    </div>
                                </div>
                            </div>
                            <div>
                                <label className={styles.label}>Modulverweis</label>
                                <input
                                    className={styles.input}
                                    value={mod.anchor_id}
                                    onChange={e => {
                                        const copy = [...moduleInfos];
                                        copy[index].anchor_id = e.target.value;
                                        setModuleInfos(copy);
                                    }}
                                />
                            </div>

                            <div>
                                <label className={styles.label}>Kategorie</label>
                                <Select
                                    value={categories.find(c => c.value === mod.category)}
                                    onChange={(selected) => {
                                        const copy = [...moduleInfos];
                                        copy[index].category = selected.value;
                                        setModuleInfos(copy);
                                    }}
                                    options={categories}
                                    placeholder="Kategorie auswählen"
                                    classNamePrefix="select"
                                />
                            </div>
                        </fieldset>
                    ))}
                </div>

                <button
                    type="button"
                    onClick={() =>
                        setModuleInfos([
                            ...moduleInfos,
                            { title: '', iconPath: '', iconText: '', category: '', anchor_id: '' }
                        ])
                    }
                >
                    + Weitere Modul-Information hinzufügen
                </button>

                {/* ======= PERSONEN SELECTION ======= */}
                <h3>Die nachfolgenden Informationen betreffen die oben genannten Module</h3>
                <fieldset className={styles.group} style={{ position: 'relative' }}>
                    <div className={styles.selection}>
                        <label className={styles.label}>Beteiligte Personen</label>
                        <PersonSelection
                            persons={assignments}
                            allPersons={allPersons}
                            disableSelect={false}
                            onAddPerson={addContact}
                            onRemovePerson={removeContact}
                            onUpdatePosition={updatePosition}
                            onUpdateTask={updateAufgabe}
                            onToggleEmail={toggleEmailVisibility}
                            onTogglePhone={togglePhoneVisibility}
                        />
                    </div>
                </fieldset>
                <fieldset className={styles.group} style={{ position: 'relative' }}>
                    <div>
                        <label className={styles.label}>Termine</label>
                        <AppointmentEditor
                            appointments={appointments}
                            onChange={(updatedAppointments) => setAppointments(updatedAppointments)}
                        />
                    </div>
                </fieldset>
                {/* ======= WYSIWYG SECTIONS ======= */}
                <div>
                    <label className={styles.label}>Hauptbeschreibung</label>
                    <Editor editorState={main_text} onEditorStateChange={setmain_text} wrapperClassName={styles.editor} toolbar={toolbar} />
                </div>

                <div>
                    <label className={styles.label}>Zielgruppe</label>
                    <Editor editorState={ziel_gruppe} onEditorStateChange={setziel_gruppe} wrapperClassName={styles.editor} toolbar={toolbar} />
                </div>

                <div>
                    <label className={styles.label}>Kosten</label>
                    <Editor editorState={kosten} onEditorStateChange={setKosten} wrapperClassName={styles.editor} toolbar={toolbar} />
                </div>

                <div>
                    <label className={styles.label}>Mitbringen</label>
                    <Editor editorState={mitbringen} onEditorStateChange={setMitbringen} wrapperClassName={styles.editor} toolbar={toolbar} />
                </div>

                <div>
                    <label className={styles.label}>Infos zum Lehrer</label>
                    <Editor editorState={infos_lehrer} onEditorStateChange={setinfos_lehrer} wrapperClassName={styles.editor} toolbar={toolbar} />
                </div>

                <div className={styles.actions}>
                    <button className={stylesDefault.greenButton} onClick={handleSubmit}>Speichern</button>
                    <button className={stylesDefault.redButton} onClick={onClose}>Abbrechen</button>
                </div>

                {/* ======= ICON PICKER MODAL ======= */}
                {showIconPicker && selectedModuleIndex !== null && (
                    <div className={stylesDefault.modalOverlay}>
                        <div className={styles.iconPicker}>
                            <Icons.X className={styles.closeX} onClick={() => {
                                setShowIconPicker(false);
                                setSelectedModuleIndex(null);
                            }} />
                            <h3>Icon auswählen</h3>

                            {/* Suchfeld */}
                            <input
                                type="text"
                                placeholder="Suche nach Titel oder Kategorie..."
                                className={styles.searchInput}
                                value={searchTerm}
                                onChange={(e) => setSearchTerm(e.target.value)}
                            />

                            {/* Gefilterte Icons */}
                            <div className={styles.iconGrid}>
                                {iconOptions
                                    .filter(icon =>
                                        icon.title?.toLowerCase().includes(searchTerm.toLowerCase()) ||
                                        icon.category?.toLowerCase().includes(searchTerm.toLowerCase())
                                    )
                                    .map(icon => (
                                        <div
                                            key={icon.id}
                                            className={styles.iconCard}
                                            onClick={() => {
                                                setModuleInfos(prev => {
                                                    const updated = [...prev];
                                                    updated[selectedModuleIndex].iconPath = icon.filepath;
                                                    updated[selectedModuleIndex].iconText = icon.altText;
                                                    return updated;
                                                });
                                                setShowIconPicker(false);
                                                setSelectedModuleIndex(null);
                                            }}
                                        >
                                            <img
                                                src={icon.filepath}
                                                alt={icon.alttext || icon.title}
                                                className={styles.iconOption}
                                            />
                                            <div className={styles.iconLabel}>
                                                {icon.title}
                                            </div>
                                        </div>
                                    ))}
                            </div>

                            <div className={styles.buttonDiv}>
                                <button className={styles.closeButton} onClick={() => {
                                    setShowIconPicker(false);
                                    setSelectedModuleIndex(null);
                                }}>
                                    Schließen
                                </button>
                            </div>
                        </div>
                    </div>
                )}
            </div>
        </div>
    );
}
